const REMOTE_SERVER = 'https://bibleapi.iosx.in/';
export default REMOTE_SERVER;